import { BufferAttribute, BufferGeometry } from "three"

export function packPosUVColorSwayIndBuffers(
  positions: Float32Array,
  uvs: Float32Array,
  colors: Float32Array,
  swayWeight: Float32Array,
  indices: Uint32Array,
) {
  const arrays = [
    positions,
    uvs,
    colors,
    swayWeight,
    indices,
  ]

  // Compute total byte length
  const totalBytes = arrays.reduce((sum, arr) => sum + arr.byteLength, 0)
  const packedBuffer = new ArrayBuffer(totalBytes)

  const meta: Array<PosUVColorSwayInd_UnpackGeometryMeta> = [] // store info for unpacking later
  let offset = 0

  for (const arr of arrays) {
    const dest = new Uint8Array(packedBuffer, offset, arr.byteLength)
    dest.set(new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength))
    meta.push({ byteOffset: offset, length: arr.length, type: arr.constructor.name })
    offset += arr.byteLength
  }

  return { buffer: packedBuffer, meta }
}

export interface PosUVColorSwayInd_UnpackGeometryMeta {
  byteOffset: number,
  length: number,
  type: string,
}

export interface UnpackPosUVColorSwayIndGeometryInput {
  buffer: ArrayBuffer,
  meta: PosUVColorSwayInd_UnpackGeometryMeta[],
}

export function unpackPosUVColorSwayIndGeometry(
  input: UnpackPosUVColorSwayIndGeometryInput,
) {
  const { buffer: packedBuffer, meta } = input
  const [positionsMeta, uvsMeta, colorsMeta, swayMeta, indicesMeta] = meta

  const positions = new Float32Array(packedBuffer, positionsMeta.byteOffset, positionsMeta.length)
  const uvs = new Float32Array(packedBuffer, uvsMeta.byteOffset, uvsMeta.length)
  const colors = new Float32Array(packedBuffer, colorsMeta.byteOffset, colorsMeta.length)
  const swayWeight = new Float32Array(packedBuffer, swayMeta.byteOffset, swayMeta.length)
  const indices = new Uint32Array(packedBuffer, indicesMeta.byteOffset, indicesMeta.length)

  const geometry = new BufferGeometry()
  geometry.setAttribute('position', new BufferAttribute(positions, 3))
  geometry.setAttribute('uv', new BufferAttribute(uvs, 2))
  geometry.setAttribute('color', new BufferAttribute(colors, 3))
  geometry.setAttribute('swayWeight', new BufferAttribute(swayWeight, 1))
  geometry.setIndex(new BufferAttribute(indices, 1))
  geometry.computeVertexNormals()

  return geometry
}
